import {getCenterPeopleTotalFlow, getCenterPeopleFlowList} from '../../../api/eastCoastMonitorApi/centerPeopleFlowApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  centerTotalPeopleFlow: {},
  centerPeopleFlowList: []
}

const getters = {
  getCenterOverViewData: state => (scenicAreaId = -1) => {
    let targets = state.centerPeopleFlowList
    if(scenicAreaId !== -1) {
      targets = state.centerPeopleFlowList.filter(item => item.scenicAreaId === scenicAreaId)
    }

    const total = targets.reduce((total, currentObj) => { 
        return { 
          peopleCameIn: total.peopleCameIn + currentObj.peopleCameIn ,
          peopleCameOut: total.peopleCameOut + currentObj.peopleCameOut ,
          peopleInsite: total.peopleInsite + currentObj.peopleInsite ,
        }
      }, 
      //初始物件做累加
      {peopleCameIn: 0, peopleCameOut: 0, peopleInsite: 0}  
    );

    return total
  },

  getSearchCountData: state => (condition = {}) => {
    const resultData = []

    let targets = state.centerPeopleFlowList
    if(condition.scenicAreaId !== -1) {
      targets = state.centerPeopleFlowList.filter(item => item.scenicAreaId === condition.scenicAreaId)
    }

    targets.forEach(e => {
      switch(condition.type) {
        case CONST.PEOPLE_IN_OUT_TYPE.NONE:
          resultData.push({scenicAreaName: e.scenicAreaName, inOut: CONST.PEOPLE_IN_OUT.IN, count: e.peopleCameIn})
          resultData.push({scenicAreaName: e.scenicAreaName, inOut: CONST.PEOPLE_IN_OUT.OUT, count: e.peopleCameOut})
          break
        case CONST.PEOPLE_IN_OUT_TYPE.IN:
          resultData.push({scenicAreaName: e.scenicAreaName, inOut: CONST.PEOPLE_IN_OUT.IN, count: e.peopleCameIn})
          break
  
        case CONST.PEOPLE_IN_OUT_TYPE.OUT:
          resultData.push({scenicAreaName: e.scenicAreaName, inOut: CONST.PEOPLE_IN_OUT.OUT, count: e.peopleCameOut})
          break  
      }
    })

    return resultData
  }
}

const actions = {
  async getPeopleTotalFlow({ commit }, condition = {}) {
    const result = await getCenterPeopleTotalFlow(condition)

    if(result.success){
      commit('centerTotalPeopleFlow', result.data)
    }
  },

  async getCenterPeopleFlowList({ commit }, condition = {}) {
    const result = await getCenterPeopleFlowList(condition)

    if(result.success){
      commit('centerPeopleFlowList', result.data)
    }
  },
}

const mutations = {
  centerTotalPeopleFlow(state, data) {
    state.centerTotalPeopleFlow = data
  },

  centerPeopleFlowList(state, data) {
    state.centerPeopleFlowList = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}